import React, { Component } from "react";
import { connect } from "react-redux";

import Profile from "../components/Profile";
import OldMemberModal from "../components/oldMemberModal/OldMemberModal";

import {
  getUserData,
  showToast,
  downloadResume
} from "../../../../actions/user.actions";
import Toast from "../../../../components/common/toast/Toast";

class ProfileContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOldMemberModal: localStorage.getItem("isOldMember")
    };

    localStorage.removeItem("isOldMember");

    this.onHide = this.onHide.bind(this);
    this.onToastClose = this.onToastClose.bind(this);
    this.downloadResume = this.downloadResume.bind(this);
  }

  componentDidMount() {
    this.props.getUserData();
    if (this.props.show) {
      this.toast.showToast(this.onToastClose);
    }
  }

  downloadResume(e) {
    e.preventDefault();

    // Flag to know if we need to download the resume or just view (open) it
    const download = e.target.dataset.download === "true";

    if (this.props.user.id) {
      this.props.downloadResume(this.props.user.id, download);
    }
  }

  onToastClose() {
    this.props.showToast(false);
  }

  onHide() {
    this.setState({
      showOldMemberModal: false
    });
  }

  renderOldMemberModal() {
    return this.state.showOldMemberModal ? (
      <OldMemberModal onHide={this.onHide} />
    ) : null;
  }

  render() {
    return (
      <div>
        {this.renderOldMemberModal()}
        <Toast
          onRef={ref => (this.toast = ref)}
          title="Your profile edits have been saved."
        />
        <Profile
          handleClick={this.handleClick}
          userData={this.props.user}
          downloadResume={this.downloadResume}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data,
    show: state.user.showToast
  };
};

const mapDispatchToProps = dispatch => ({
  getUserData: () => dispatch(getUserData()),
  showToast: show => dispatch(showToast(show)),
  downloadResume: (userId, download) =>
    dispatch(downloadResume(userId, download))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/containers/ProfileContainer.js